import { jsxs, jsx } from "react/jsx-runtime";
import assert from "assert";
import { Box } from "../Box/Box.mjs";
import { ButtonIcon } from "../ButtonIcon/ButtonIcon.mjs";
import { Text } from "../Text/Text.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { clearGutter } from "./Tag.css.mjs";
import { IconAdd } from "../icons/IconAdd/IconAdd.mjs";
import { IconClear } from "../icons/IconClear/IconClear.mjs";
const tagSizes = ["small", "standard"];
const paddingXForSize = {
  small: "xsmall",
  standard: "small"
};
const Tag = ({
  size = "standard",
  data,
  id,
  icon,
  children,
  ...restProps
}) => {
  assert(
    typeof children === "undefined" || typeof children === "string",
    "Tag may only contain a string"
  );
  assert(
    !icon || icon.props.size === void 0 || icon.props.tone === void 0,
    "Icons cannot set the 'size' or 'tone' prop when passed to a Tag component"
  );
  let label = "Clear";
  let handler;
  const clearable = "onClear" in restProps && restProps.onClear;
  const addable = "onAdd" in restProps && restProps.onAdd;
  if (clearable) {
    label = restProps.clearLabel;
    handler = restProps.onClear;
  } else if (addable) {
    label = restProps.addLabel;
    handler = restProps.onAdd;
  }
  const hasButton = clearable || addable;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      id,
      display: "flex",
      gap: "xxsmall",
      alignItems: "center",
      background: addable ? "formAccentSoft" : "neutralLight",
      paddingY: "xxsmall",
      paddingX: paddingXForSize[size],
      paddingRight: hasButton ? "xsmall" : paddingXForSize[size],
      borderRadius: "full",
      title: children,
      maxWidth: "content",
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: [
        /* @__PURE__ */ jsxs(
          Text,
          {
            size,
            baseline: false,
            maxLines: 1,
            tone: addable ? "formAccent" : void 0,
            children: [
              icon,
              " ",
              children
            ]
          }
        ),
        hasButton ? /* @__PURE__ */ jsx(Box, { className: clearGutter, children: /* @__PURE__ */ jsx(
          ButtonIcon,
          {
            icon: addable ? /* @__PURE__ */ jsx(IconAdd, {}) : /* @__PURE__ */ jsx(IconClear, { tone: "secondary" }),
            label,
            size: "small",
            tone: addable ? "formAccent" : "neutral",
            variant: "transparent",
            onClick: handler
          }
        ) }) : null
      ]
    }
  );
};
export {
  Tag,
  tagSizes
};
